import cookie from 'cookie';

export default function getUsername () {
  return cookie.parse(document.cookie).username;
}
